export enum AvailableOperation {
  Start = 1,
  Request = 2,
}
